// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import moment from 'moment'

const date1comesAfterdate2 = (date1, date2) => {
  const d1 = moment(date1, 'YYYY/MM/DD').valueOf()
  const d2 = moment(date2, 'YYYY/MM/DD').valueOf()
  return d1 > d2
}

export default date1comesAfterdate2
